import React, { useContext } from 'react';

import { Box } from '@chakra-ui/react';
import { components } from 'react-select';
import { customTheme } from 'theme';

import { SourceMenuTextContext } from 'containers/Visibility/SecurityGraphNext/utils/sourceMenuContext';

const bandStyles = {
  px: 3,
  py: 1.5,
  fontSize: 12,
  color: customTheme.colors.gray['300'],
  bg: 'white',
  borderColor: customTheme.colors.gray['200'],
};

// The entity dropdown's menu: a count header that stays at the top while
// scrolling, and a footer at the bottom saying whether more entries load.
export const SourceEntityMenuList = props => {
  const { header, footer } = useContext(SourceMenuTextContext);
  return (
    <components.MenuList {...props}>
      {header && (
        <Box
          {...bandStyles}
          position="sticky"
          top={0}
          zIndex={1}
          borderBottom="1px solid"
        >
          {header}
        </Box>
      )}
      {props.children}
      {footer && (
        <Box {...bandStyles} textAlign="center" borderTop="1px solid">
          {footer}
        </Box>
      )}
    </components.MenuList>
  );
};
